<template>
    <form-accordion
        name="contract-information"
        section="Commercial Contract Information"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <purchase-price
            :read_only="read_only"
        />

        <contract-date
            :read_only="read_only"
        />

        <inspection
            :inspection="property.inspection"
            :read_only="read_only"
        />

        <attorney-review
            :attorney="property.attorney"
            :read_only="read_only"
        />

        <feasibility-period-index
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <financing-contingency
            :mortgage="property.mortgage"
            :read_only="read_only"
        />

        <closing-date
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <titleease-order-tile
            v-if="titleease_enabled"
            :property="property"
            :order_title_route="order_title_route"
            :order_status_route="order_status_route"
            :contract_documents_route="contract_documents_route"
            :read_only="read_only"
        />

        <closing-early
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <closing-extend
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <earnest-money-index
            :commercial="property.commercial"
            :deal="property.deal"
            :read_only="read_only"
        />

        <option-fee-index
            :commercial="property.commercial"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import PurchasePrice from './purchase-price.vue';
import ContractDate from './contract-date.vue';
import Inspection from './inspection.vue';
import AttorneyReview from './attorney-review.vue';
import FinancingContingency from './financing-contingency.vue';
import ClosingDate from './closing-date.vue';
import ClosingEarly from './closing-early.vue';
import ClosingExtend from './closing-extend.vue';
import EarnestMoneyIndex from './earnest-money/earnest-money-index.vue';
import OptionFeeIndex from './option-fee/option-fee-index.vue';
import FeasibilityPeriodIndex from './feasibility-period/feasibility-period-index.vue';
import TitleeaseOrderTile from '../../../referrals/titleease/titleease-order-tile.vue';

export default {
    components: {
        PurchasePrice,
        ContractDate,
        Inspection,
        AttorneyReview,
        FinancingContingency,
        ClosingDate,
        ClosingEarly,
        ClosingExtend,
        EarnestMoneyIndex,
        OptionFeeIndex,
        FeasibilityPeriodIndex,
        TitleeaseOrderTile,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
        order_title_route: {},
        order_status_route: {},
        contract_documents_route: {},
        titleease_enabled: { default: false },
    },
}
</script>
